
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/antara/tutorials/overview-of-antara-modules-part-i",
      function () {
        return require("private-next-pages/docs/antara/tutorials/overview-of-antara-modules-part-i/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/antara/tutorials/overview-of-antara-modules-part-i"])
      });
    }
  